import { Pipe, PipeTransform } from '@angular/core';
import { ConsentDeliveryChannel, CONSENT_DELIVERY_CHANNEL_OPTIONS } from '../models/consent.model';

@Pipe({
  name: 'consentDeliveryChannel'
})
export class ConsentDeliveryChannelPipe implements PipeTransform {
  transform(value: ConsentDeliveryChannel | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }
    
    const option = CONSENT_DELIVERY_CHANNEL_OPTIONS.find(opt => opt.value === value);
    return option ? option.label : '';
  }
}
